import { IIdName, IOperations } from "../../util/varibles/interface";

export interface DashboardState {
    operations: any[]
    vessels: any[]
    productionAreas: IIdName[]
    target: any

    popupInfo: {
        isShow: boolean
        values?: any
    },

    tracking: boolean
    loadingProdAreas: boolean,
    loadingOp: boolean
    loadingVessels: boolean

    // Site side
    opsSite: IOperations
}

export const initialState: DashboardState = {
    operations: [],
    vessels: [],
    productionAreas: [],

    target: {},

    popupInfo: {
        isShow: false
    },

    tracking: false,
    loadingProdAreas: false,
    loadingOp: false,
    loadingVessels: false,

    opsSite: {},
};